import classNames from 'classnames';
import { forwardRef } from 'react';
const containerWrapperCss = "c17tq4t4";
const ContainerWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerWrapperCss, props.className)} />;
});
export const Container = ({
  children,
  ...restProps
}) => <ContainerWrapper {...restProps}>
    {children}
  </ContainerWrapper>;

require("./container.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./container.js");